import React from 'react';
import SelectField from '../../../../../../web-app-components/components/SelectField';
import MenuItem from '@material-ui/core/MenuItem';

const LANGUAGES = [
  { value: 'lt-LT', label: 'Lietuvių kalba (LT)' },
  { value: 'en-EU', label: 'English (EN-EU)' },
];

const LanguageSelectField = (props) => {
  return (
    <SelectField {...props}>
      {LANGUAGES.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </SelectField>
  );
};

export default LanguageSelectField;
